<template>
  <div>
  <!-- Page Title-->
    <div class="page-title">
      <div class="container">
        <h1>Contacts</h1>
        <ul class="breadcrumbs">
          <li><a href="index.html">Home</a>
          </li>
          <li class="separator">&nbsp;/&nbsp;</li>
          <li>Contacts</li>
        </ul>
      </div>
    </div>
    <!-- Page Content-->
    <div class="container padding-bottom-2x mb-2">
      <div class="row">
        <div class="col-md-7">
          <div class="display-3 text-muted opacity-75 mb-30"><strong> Service Clients </strong></div>
        </div>
        <div class="col-md-5">
          <ul class="list-icon">
            <li> <i class="material-icons mail_outline text-muted"></i><a class="navi-link" href="mailto:customer.service@unishop.com">contact@luxuryshopdz.com</a></li>
            <li> <i class="material-icons phone text-muted"></i> 023 804 474 / 021 436 272</li>
            <li> <i class="material-icons access_time text-muted"></i>1 - 2 jours ouvrables</li>
          </ul>
        </div>
      </div>
      <hr class="margin-top-2x">
      <div class="row margin-top-2x">
        <div class="col-md-7">
          <div class="display-3 text-muted opacity-75 mb-30"><strong> Support technique </strong></div>
        </div>
        <div class="col-md-5">
          <ul class="list-icon">
            <li> <i class="material-icons mail_outline text-muted"></i><a class="navi-link" href="mailto:support@unishop.com">support@luxuryshopdz.com</a></li>
            <li> <i class="material-icons phone text-muted"></i> 023 804 474 / 021 436 272</li>
            <li> <i class="material-icons access_time text-muted"></i>1 - 2 jours ouvrables</li>
          </ul>
        </div>
      </div>
      <h2 class="margin-top-3x text-center mb-30">Siège socials</h2>
      <div class="d-flex justify-content-center">
          <div class="card border-default mb-30">

            <div class="card-body bg-dark">
              <ul class="list-icon text-sm text-white">
                <li> <i class="material-icons place text-muted"></i> Magasin '1': Centre commercial mohammadia mall , les bannaniers alger (sous sol ) magasin numéro 869</li>
                <li> <i class="material-icons phone text-muted"></i>023 804 474</li>
                <li> <i class="material-icons mail_outline text-muted"></i><a class="navi-link-light" href="mailto:orlando.store@unishop.com">support@luxuryshopdz.com</a></li>
              </ul>
            </div>
            </div>

          <div class="card border-default mb-30">

            <div class="card-body bg-dark">
              <ul class="list-icon text-sm text-white">
                <li> <i class="material-icons place text-muted"></i> Magasin '2' : 07 rue hamdani lahcen,sidi yahia sur la montée vers paradou (à coté de mobilis)</li>
                <li> <i class="material-icons phone text-muted"></i> 021 436 272</li>
                <li> <i class="material-icons mail_outline text-muted"></i><a class="navi-link-light" href="mailto:chicago.store@unishop.comm">support@luxuryshopdz.com</a></li>
              </ul>
            </div>
          </div>
           <div class="card border-default mb-30">

            <div class="card-body bg-dark">
              <ul class="list-icon text-sm text-white">
                <li> <i class="material-icons place text-muted"></i>Magasin '3': Cité Point du jour Coop.Ibn Sina N132 .ORAN </li>
                <li> <i class="material-icons phone text-muted"></i> 021 436 272</li>
                <li> <i class="material-icons mail_outline text-muted"></i><a class="navi-link-light" href="mailto:chicago.store@unishop.comm">support@luxuryshopdz.com</a></li>
              </ul>
            </div>
          </div>
           <div class="card border-default mb-30">

            <div class="card-body bg-dark">
              <ul class="list-icon text-sm text-white">
                <li> <i class="material-icons place text-muted"></i>Magasin '4': elkhroub en face EX daira de lekhroub , constantine</li>
                <li> <i class="material-icons phone text-muted"></i> 021 436 272</li>
                <li> <i class="material-icons mail_outline text-muted"></i><a class="navi-link-light" href="mailto:chicago.store@unishop.comm">support@luxuryshopdz.com</a></li>
              </ul>
            </div>
          </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.page-title {
  margin-top: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue